export const urls = {
  GET_VRSTAUSLUGE: 'VrsteUsluge/vrati_vrste_usluga',
  GET_KUPCE: 'Combo/vrati_kupce_combo',
  INSERT_VRSTAUSLUGE: 'VrsteUsluge/unos_vrste_usluge',
  UPDATE_VRSTAUSLUGE: 'VrsteUsluge/izmena_vrste_usluge',
  DELETE_VRSTAUSLUGE: 'VrsteUsluge/brisanje_vrste_usluge',
  GET_KORISNIK_ZA_ID: 'KorisniciPrograma/vrati_korisnika_programa_za_id',
  GET_KATEGORIJE: 'Combo/vrati_kategorije_zaposlenih',
};
